import { createReducer, on } from '@ngrx/store';
import * as baseState from '../../../../core/models/base-state/base-state';
import { RemovedItemNotices } from '../../models/removed-item-notice';
import * as actions from '../actions/removed-item-notices.actions';

export const removedItemNoticesFeatureKey = 'removed-item-notices';

export interface RemovedItemNoticesState {
  baseState: baseState.BaseState;
  notices: RemovedItemNotices | null;
}

export const initialState: RemovedItemNoticesState = {
  baseState: baseState.createBaseState(undefined),
  notices: null,
};

export const removedItemNoticesReducer = createReducer<RemovedItemNoticesState>(
  initialState,
  on(
    actions.getRemovedItemNotices,
    (state): RemovedItemNoticesState => ({
      ...state,
      baseState: {
        ...state.baseState,
        error: null,
        isLoading: true,
      },
    })
  ),
  on(
    actions.getRemovedItemNoticesSuccess,
    (state, { notices }): RemovedItemNoticesState => ({
      ...state,
      notices,
      baseState: {
        ...state.baseState,
        error: null,
        isLoading: false,
      },
    })
  ),
  // a failed read keeps nothing stale on screen: the notices are dropped, not left from an earlier read
  on(
    actions.getRemovedItemNoticesFailure,
    (state, { error }): RemovedItemNoticesState => ({
      ...state,
      notices: null,
      baseState: {
        ...state.baseState,
        error,
        isLoading: false,
      },
    })
  )
);
